import app from "/src/app/app.module";
import './documentation.html';

app.controller('documentation-controller', function($scope, vxSession, $http, $sce) {
    // Base URL for the documentation:
    const baseDocsUrl = "/api/docs?authorization="+vxSession.token;
    // Add the token as a query parameter:
    $scope.iframeUrl = $sce.trustAsResourceUrl(baseDocsUrl );

});